/**
* Content Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const screenWidth = $( window ).width();
      function closeAnnouncementBanner() {
        $( '#announcement-banner' ).slideUp( 0, function() {
          $( ':root' ).css( '--announcementBannerHeight', `0px` );
        } );
      }
      function openAnnouncementBanner() {
        $( '#announcement-banner' ).slideDown( 0, function() {
          $( ':root' ).css( '--announcementBannerHeight', `${announcementBannerHeight}px` );
        } );
        announcementBannerHeight();
      }
      function announcementBannerHeight() {
        if ( $( '#announcement-banner:not([style*="display:none;"])' ).length ) {
          const announcementBannerHeight = $( '#announcement-banner' ).outerHeight();
          $( ':root' ).css( '--announcementBannerHeight', `${announcementBannerHeight}px` );
        }
      }

      window.debounce = require( 'lodash/debounce' );

      $( window ).on( 'resize', debounce( function( e ) {
        if ( $( window ).width() >= 1024 ) {
          console.log( 'Screen is larger than 1024px.' );
          announcementBannerHeight();
        }
      }, 100 ) );

      if ( screenWidth >= 1024 ) {
        announcementBannerHeight();

        $( window ).on( 'resize', debounce( function() {
          announcementBannerHeight();
        }, 100 ) );

        if ( !sessionStorage.getItem( 'announcement-bannerseen' ) ) {
          sessionStorage.setItem( 'announcement-bannerseen', 'false' );
        }
        if ( sessionStorage.getItem( 'announcement-bannerseen' ) === 'false' ) {
          openAnnouncementBanner();
        }

        $( '#announcement-banner__close' ).on( 'click', function() {
          closeAnnouncementBanner();
          sessionStorage.setItem( 'announcement-bannerseen', 'true' );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
